import { useMemo } from "react";
import { usePutAITrafficControlSegmentsQuery } from "@tiny/api";

interface UseAITrafficSegmentDetailsDialogProps {
  aiTrafficControlId: string;
  open: boolean;
}

export const useAITrafficSegmentDetailsDialog = (
  props: UseAITrafficSegmentDetailsDialogProps
) => {
  const { aiTrafficControlId, open } = props;

  const segmentsFilter = useMemo(() => {
    return {
      aiTrafficControlIds: [aiTrafficControlId],
    };
  }, [aiTrafficControlId]);

  const {
    data: segmentsData,
    refetch: refetchSegments,
    isLoading: isLoadingSegments,
  } = usePutAITrafficControlSegmentsQuery(segmentsFilter, {
    enabled: open && !!aiTrafficControlId,
    keepPreviousData: true,
  });

  const trafficControlData = useMemo(() => {
    if (!segmentsData || segmentsData.aiTrafficControlSegments.length === 0)
      return null;

    const control = segmentsData.aiTrafficControlSegments[0];

    return {
      aiTrafficControlId: control.aiTrafficControlId,
      aiTrafficControlName: control.aiTrafficControlName,
      segments: control.segments?.map((segment: any) => ({
        segmentId: segment.segmentId,
        segmentName: segment.segmentName,
        numberOfCustomers: segment.numberOfCustomers,
        priority: segment.priority,
        enabled: segment.enabled,
        isActive: segment.isActive,
      })),
    };
  }, [segmentsData]);

  return {
    trafficControlData,
    isLoadingSegments,
    refetchSegments,
  };
};
